module.exports = __webpack_public_path__ + "static/media/marshallPanama.ce8e943b.png";